
















































import Vue from 'vue'
import GatewayLog from "@/views/console/remote-connect-manage/component/GatewayLog.vue";
import TrafficData from "@/views/console/remote-connect-manage/component/TrafficData.vue";
import HistoricalTraffic from "@/views/console/remote-connect-manage/component/HistoricalTraffic.vue";
import ConnectionConfig from "@/views/iot-console/gateway-admin/components/ConnectionConfig.vue";
export default Vue.extend({
  components: {
    ConnectionConfig,
    HistoricalTraffic,
    TrafficData,
    GatewayLog,
  },
  props: {
    gateway:{
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      activeKey:'configure'
    }
  },
  computed: {
    gatewayCode(){
      return this.gateway?.code || ''
    }
  },
  mounted() {
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    callback(key){
      this.activeKey = key
    },
    loadData(){
      if (this.activeKey === 'configure'){
        this.$refs.connectCg.getDeviceListInfo()
      }
      if (this.activeKey === 'log'){
        this.$nextTick(()=>{
          this.$refs.gatewayLog.searchList()
        })
      }
      if (this.activeKey === 'reltimeTraffic'){
        this.$nextTick(()=>{
          this.$refs.trafficData.init()
        })
      }
      if (this.activeKey === 'histryTraffic'){
        let endTime = Date.now()
        let startTime = endTime - (24*60*60*1000)
        this.$nextTick(()=>{
          this.$refs.histryTraffic.searchData(startTime,endTime)
        })
      }
    }

  },
  watch:{
    activeKey(){
      this.loadData()
    },
    gatewayCode(){
      this.loadData()
    }
  }
})
